interface InvoiceStatusNoticeProps {
  hasInvoice?: number | string | null;
  invoiceStatus?: number | string | null;
}

export default function InvoiceStatusNotice({
  hasInvoice,
  invoiceStatus,
}: InvoiceStatusNoticeProps) {
  if (Number(hasInvoice) !== 1) return null;

  const status = invoiceStatus == null ? null : Number(invoiceStatus);
  const issued = status === 2;

  return (
    <div
      className="mx-4 mt-3 px-4 py-3 rounded-2xl flex items-start gap-2"
      style={{
        background: issued ? "#ECFDF5" : "#FFF7ED",
        border: issued ? "1px solid #A7F3D0" : "1px solid #FED7AA",
      }}
    >
      <i
        className={issued ? "ri-checkbox-circle-fill" : "ri-time-line"}
        style={{
          color: issued ? "#10B981" : "#D97706",
          fontSize: 18,
          lineHeight: "20px",
        }}
      />
      <div className="min-w-0">
        <div
          className="text-sm font-semibold leading-tight"
          style={{ color: issued ? "#047857" : "#B45309" }}
        >
          {issued ? "发票已开票" : "发票申请中"}
        </div>
        <div className="text-xs mt-1" style={{ color: "#6B7280" }}>
          {issued
            ? "发票已开具，可前往发票记录查看。"
            : "开票申请已提交，平台正在处理中。"}
        </div>
      </div>
    </div>
  );
}
